"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateInn = void 0;
const validateInn = (inn) => {
    if (inn.length === 10) {
        return checkDigit(inn, [2, 4, 10, 3, 5, 9, 4, 6, 8]) === Number(inn[9]);
    }
    else if (inn.length === 12) {
        return (checkDigit(inn, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]) === Number(inn[10]) &&
            checkDigit(inn, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]) === Number(inn[11]));
    }
    return false;
};
exports.validateInn = validateInn;
const checkDigit = (inn, coefficients) => {
    const n = coefficients.reduce((sum, coefficient, index) => sum + coefficient * Number(inn[index]), 0);
    return (n % 11) % 10;
};
//# sourceMappingURL=validate-inn.js.map